import { createSelector } from '@reduxjs/toolkit';

import { specialPromosBlocksSelector } from '../specialPromosBlocks/specialPromosBlocksSelector';

export const mortgageBannerSelector = createSelector(specialPromosBlocksSelector, state => state.mortgageBanner);
